/** Admin: a bay's equipment configuration (controllers, relays, inputs, behavior) for an owner — 1.4 P17 twin. */
import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { useLocalSearchParams, Stack } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import ContentContainer from '../../../../../src/components/ContentContainer';
import BayEquipmentConfig from '../../../../../src/components/bay/BayEquipmentConfig';
import { spacing } from '../../../../../src/utils/theme';

export default function AdminOwnerBayEquipmentScreen() {
  const { id, bayId, bayType, bayName } = useLocalSearchParams<{ id: string; bayId: string; bayType?: string; bayName?: string }>();
  return (
    <OwnerScopeProvider ownerId={id ?? null}>
      <Stack.Screen options={{ title: bayName ? `${bayName} · Equipment` : 'Bay Equipment' }} />
      <ScrollView contentContainerStyle={styles.scroll}>
        <ContentContainer>
          <BayEquipmentConfig bayId={bayId ?? ''} bayType={bayType ?? 'automatic'} />
        </ContentContainer>
      </ScrollView>
    </OwnerScopeProvider>
  );
}

const styles = StyleSheet.create({ scroll: { padding: spacing.lg } });
